import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl, setupManagementUrl} from "../../../../config";
import { AccountTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {
  allAccountCategories,
  allAccountTypes,
  allAccounts,
  allBanks,
  allBanksTransactionKeywords,
  allPaymentTypes,
} from "../../../../data/Axios/queries";
import {
  AccountCategoriesColumns,
  AccountSubCategoriesColumns,
  AccountsColumns,
  BankTransactionKeyWordColumns,
  BanksColumns,
  PaymentTypesColumns,
} from "../../../../data/DynamicTable/AccountsColumns";
import AccountCategoryForm from "./form";
import AccountsForm from "./form";
import PaymentTypeForm from "./form";
import BankTransactionKeywordForm from "./form";
const base_url = setupManagementUrl.uri;
const actions = {
  entity: "BankTransactionKeywords",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};
function BanksTransactionKeywordTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Bank Transaction KeyWords"
        subtitle="Create, view or edit bank Transaction Keywords
        "
        columns={BankTransactionKeyWordColumns}
        FormComponent={BankTransactionKeywordForm}
        query={allBanksTransactionKeywords}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default BanksTransactionKeywordTable;
